import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { JPMAM_JOB_BASE_PATH } from '../../../../../../../../../features/vendor/jpmam/job/jpmam-job-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/job/_job')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'jpmam-job-list',
        label: 'J.P. Morgan',
        to: JPMAM_JOB_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
